import { getToken } from '@/utils/adminAuth'
import { request } from './http'

function resolveApiBase() {
  const fromEnv = process.env.VUE_APP_API_BASE
  if (fromEnv != null && String(fromEnv).trim() !== '') {
    return String(fromEnv).replace(/\/$/, '')
  }
  return ''
}

export function resolveUploadUrl(urlOrPath) {
  if (!urlOrPath) return ''
  if (/^https?:\/\//i.test(urlOrPath)) return urlOrPath

  let path = String(urlOrPath).trim()
  if (!path.startsWith('/')) {
    path = `/uploads/${path.replace(/^uploads\//, '')}`
  }
  path = path.replace(/^\/uploads\/uploads\//, '/uploads/')

  const base = resolveApiBase()
  if (base) return `${base}${path}`
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${path}`
  }
  return path
}

export function fetchPublicCategories() {
  return request('/api/categories')
}

export function mapStorefrontCategory(row) {
  return {
    id: row.id,
    slug: row.slug,
    nameEn: row.name_en,
    nameZh: row.name_zh || '',
    image_url: row.image_url,
    image_path: row.image_path,
    createdAt: row.created_at || ''
  }
}

/** 按创建先后排序：最先创建的在前（id 升序，其次 created_at） */
export function sortCategoriesByCreated(categories) {
  return [...categories].sort((a, b) => {
    const idA = Number(a.id) || 0
    const idB = Number(b.id) || 0
    if (idA !== idB) return idA - idB
    const tA = String(a.createdAt || a.created_at || '')
    const tB = String(b.createdAt || b.created_at || '')
    if (tA && tB) return tA.localeCompare(tB)
    return 0
  })
}

export function mapStorefrontCategories(rows) {
  return sortCategoriesByCreated((rows || []).map(mapStorefrontCategory))
}

export function categoryProductLink(slug) {
  return { path: '/products', query: { category: slug } }
}

export function fetchCategories(keyword = '') {
  const q = keyword ? `?keyword=${encodeURIComponent(keyword)}` : ''
  return request(`/api/admin/categories${q}`)
}

export function createCategory(data) {
  return request('/api/admin/categories', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

export function updateCategory(id, data) {
  return request(`/api/admin/categories/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

export function deleteCategory(id) {
  return request(`/api/admin/categories/${id}`, {
    method: 'DELETE'
  })
}

export async function uploadCategoryImage(file) {
  const formData = new FormData()
  formData.append('file', file)

  const headers = {}
  const token = getToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const res = await fetch(`${resolveApiBase()}/api/admin/categories/upload`, {
    method: 'POST',
    headers,
    body: formData
  })

  let body = null
  const text = await res.text()
  if (text) {
    try {
      body = JSON.parse(text)
    } catch {
      body = { code: res.status, message: text }
    }
  }

  if (!res.ok) {
    const err = new Error(body?.message || res.statusText || '上传失败')
    err.code = body?.code ?? res.status
    throw err
  }

  return body
}
